import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { formatUrl } from '../shared/utils/format-url-util';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { HttpRequestService } from '../shared/services/http-request.service';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  constructor(
    private httpClient: HttpRequestService,
    private errorHandler: GlobalErrorHandlerService,
  ) { }

  getProviderList(
    programCode: string,
    consumerId: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_PROVIDER_LIST, {
      programCode,
      consumerId
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
}
